import { render, staticRenderFns } from "./EventInvitationSuccess.vue?vue&type=template&id=6cc85a75&"
import script from "./EventInvitationSuccess.vue?vue&type=script&lang=js&"
export * from "./EventInvitationSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports